import React from "react";
import { Modal } from "antd";
import Button from "./button";
const CustomOkButton = ({ onClick }) => (
  <Button
    title="Yes"
    onClick={onClick}
    className="bg-lightBlue !text-black w-full focus:bg-primaryBlue !focus:text-white sm:w-19 h-5.4 !hover:shadow-none"
  />
);

const CustomNoButton = ({ onClick }) => (
  <Button
    title="No"
    onClick={onClick}
    className="bg-lightBlue hover:bg-lightBlue focus:bg-primaryBlue !focus:text-white w-full sm:w-19 h-5.4 !text-black"
  />
);

const CustomCancelButton = ({ onClick }) => (
  <Button
    title="Cancel"
    onClick={onClick}
    className="bg-lightBlue hover:bg-lightBlue focus:bg-primaryBlue !focus:text-white w-full sm:w-19 h-5.4 !text-black"
  />
);

const FreeAdsModal = ({
  onCancel,
  onOk,
  onNo,
  text,
  title,
  promo,
  details,
  issueTitle,
  issueDescription,
}) => {
  return (
    <div>
      {details ? (
        <Modal
          open={true}
          footer={null}
          className="space-y-20" // Center the modal
          onCancel={onCancel}
          width="479px"
        >
          <h3>{title}</h3>
          <p>
            <span className="font-medium">Issue Title:</span> {issueTitle}
          </p>
          <p>
            <span className="font-medium">Description:</span> {issueDescription}
          </p>
          <p></p>
        </Modal>
      ) : (
        <Modal
          open={true}
          footer={null}
          closeIcon={null} // Remove the close icon
          className="space-y-20" // Center the modal
          onCancel={onCancel}
          width="479px"
        >
          <h3>{title}</h3>
          <p>{text}</p>
          <p>{promo}</p>
          <div className="flex space-x-2 sm:space-x-2 flex-row justify-between mt-2">
            <CustomCancelButton onClick={onCancel} />
            <CustomNoButton onClick={onNo} />
            <CustomOkButton onClick={onOk} />
          </div>
        </Modal>
      )}
    </div>
  );
};
export default FreeAdsModal;
